/**
 * Password validation patterns and constants
 * These are reusable across different validation contexts
 */

export const UPPERCASE_CHARS = /[A-Z]/;
export const LOWERCASE_CHARS = /[a-z]/;
export const NUMBER_CHARS = /[0-9]/;
